// src/AppRouter.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login";
import UsersList from "../pages/UsersList";
import AdminDashboard from "../pages/AdminDashboard";
import ClientDashboard from "../pages/ClientDashboard";
import UserDashboard from "../pages/UserDashboard";
import RoleBasedRedirect from "./RoleBasedRedirect";
import BrandsList from "../pages/BrandsList";
import AgenciesList from "../pages/AgenciesList";
import TalleresNoAutorizadosList from "../pages/TalleresNoAutorizadosList";
import VehiclesList from "../pages/VehiclesList";
import UploadReport from "../pages/UploadReport";
import UploadSalesReport from "../pages/UploadSalesReport";
import SalesLocationVerification from "../pages/SalesLocationVerification";
import SalesLocationDistances from "../pages/SalesLocationDistances";
import Layout from "../components/Layout";
import MapConcentrationDashboard from "../pages/MapConcentrationDashboard";
import RFMComparisonDashboard from "../pages/RFMTotalDashboard";
import TrafficMapDashboard from "../pages/TrafficMapDashboard";
import SyncDashboard from "../pages/SyncDashboard";
import MovingTrafficDashboard from "../pages/MovingTrafficDashboard";
import ClientUserDashboard from "../pages/ClientUserDashboard";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<RoleBasedRedirect />} />
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <ProtectedRoute
            roleAllowed={["ADMIN", "CLIENT_ADMIN", "CLIENT_USER"]}
          >
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* ADMIN */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/users" element={<UsersList />} />
        <Route path="/brands" element={<BrandsList />} />
        <Route path="/agencies" element={<AgenciesList />} />
        <Route path="/sync" element={<SyncDashboard />} />
        <Route
          path="/talleres-no-autorizados"
          element={<TalleresNoAutorizadosList />}
        />
        <Route path="/vehicles" element={<VehiclesList />} />
        <Route path="/reports/upload" element={<UploadReport />} />
        <Route path="/reports/sales/upload" element={<UploadSalesReport />} />
        <Route
          path="/reports/sales/verify"
          element={<SalesLocationVerification />}
        />
        <Route
          path="/reports/sales/distances"
          element={<SalesLocationDistances />}
        />

        {/* CLIENT ADMIN / USER */}
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        <Route
          path="/client-dashboard/map"
          element={
            <ProtectedRoute roleAllowed={["ADMIN", "CLIENT_ADMIN"]}>
              <MapConcentrationDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-dashboard/rfm"
          element={
            <ProtectedRoute roleAllowed={["ADMIN", "CLIENT_ADMIN"]}>
              <RFMComparisonDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-dashboard/traffic"
          element={
            <ProtectedRoute roleAllowed={["ADMIN", "CLIENT_ADMIN", "CLIENT_USER"]}>
              <TrafficMapDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-dashboard/moving-traffic"
          element={
            <ProtectedRoute
              roleAllowed={["ADMIN", "CLIENT_ADMIN", "CLIENT_USER"]}
            >
              <MovingTrafficDashboard />
            </ProtectedRoute>
          }
        />

        {/* USER DASHBOARD */}
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route
          path="/client-user-dashboard"
          element={
            <ProtectedRoute roleAllowed={["CLIENT_USER"]}>
              <ClientUserDashboard />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<div>404 - Not Found</div>} />
    </Routes>
  );
};

export default AppRouter;
